(function () {
  'use strict';

  document.documentElement.classList.add('estilo-motion-ready');

  var prefersReduced = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var footerMediaQuery = window.matchMedia('(max-width: 749px)');

  /* ---------------------------------------------------------------
     Poster-first hero video
     --------------------------------------------------------------- */
  function initHeroVideo(scope) {
    var root = scope || document;

    root.querySelectorAll('[data-estilo-hero-video]').forEach(function (video) {
      if (video.dataset.estiloVideoInitialized === 'true') return;
      video.dataset.estiloVideoInitialized = 'true';

      var loaded = false;
      var isInViewport = true;
      var isPageVisible = document.visibilityState !== 'hidden';
      var playPending = false;
      var userPaused = false;
      var playButton = video.closest('.estilo-hero') && video.closest('.estilo-hero').querySelector('[data-estilo-hero-play]');
      var delay = Number(video.dataset.loadDelay);
      if (!Number.isFinite(delay)) {
        delay = window.matchMedia('(max-width: 749px)').matches ? 400 : 80;
      }

      function setPlayButton(label) {
        if (!playButton) return;
        playButton.textContent = label;
        playButton.removeAttribute('hidden');
      }

      setPlayButton('Play course video');

      function showVideo() {
        playPending = false;
        if (!isInViewport || !isPageVisible || userPaused) {
          if (!video.paused) video.pause();
          return;
        }
        video.classList.remove('is-poster-only', 'is-playback-blocked');
        video.classList.add('is-ready');
        setPlayButton('Pause course video');
      }

      function showPosterForBlockedPlayback() {
        playPending = false;
        video.classList.remove('is-ready', 'is-poster-only');
        video.classList.add('is-playback-blocked');
        setPlayButton('Play course video');
      }

      function tryToPlay() {
        if (!loaded || !isInViewport || !isPageVisible || userPaused || playPending || !video.isConnected) return;

        video.autoplay = true;
        video.defaultMuted = true;
        video.muted = true;
        video.playsInline = true;
        video.setAttribute('autoplay', '');
        video.setAttribute('muted', '');
        video.setAttribute('playsinline', '');
        playPending = true;

        var playPromise;
        try {
          playPromise = video.play();
        } catch (error) {
          showPosterForBlockedPlayback();
          return;
        }

        if (playPromise && typeof playPromise.then === 'function') {
          playPromise
            .then(function () {
              playPending = false;
              if (!video.paused) showVideo();
            })
            .catch(showPosterForBlockedPlayback);
        } else {
          playPending = false;
          if (!video.paused) showVideo();
        }
      }

      function loadVideo() {
        if (loaded || !video.isConnected) return;
        loaded = true;

        video.querySelectorAll('source[data-src]').forEach(function (source) {
          source.src = source.dataset.src;
        });
        video.load();

        if (isInViewport) tryToPlay();
      }

      video.addEventListener('playing', showVideo);
      video.addEventListener('pause', function () {
        playPending = false;
        setPlayButton('Play course video');
      });
      video.addEventListener('canplay', tryToPlay);
      video.addEventListener('error', function () {
        playPending = false;
        video.classList.remove('is-ready', 'is-playback-blocked');
        video.classList.add('is-poster-only');
        setPlayButton('Play course video');
      });

      if (playButton) {
        playButton.addEventListener('click', function () {
          if (video.paused || video.classList.contains('is-playback-blocked')) {
            userPaused = false;
            if (!loaded) loadVideo();
            else tryToPlay();
          } else {
            userPaused = true;
            playPending = false;
            video.pause();
          }
        });
      }

      function handleVisibilityChange() {
        if (!video.isConnected) {
          document.removeEventListener('visibilitychange', handleVisibilityChange);
          return;
        }

        isPageVisible = document.visibilityState !== 'hidden';
        if (!loaded) return;

        if (!isPageVisible) {
          playPending = false;
          if (!video.paused) video.pause();
        } else if (isInViewport && !userPaused) {
          tryToPlay();
        }
      }

      document.addEventListener('visibilitychange', handleVisibilityChange);

      // Video loads only after the shopper chooses Play.

      if ('IntersectionObserver' in window) {
        var playbackObserver = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            isInViewport = entry.isIntersecting;
            if (!loaded) return;
            if (entry.isIntersecting) {
              tryToPlay();
            } else {
              video.pause();
              playPending = false;
            }
          });
        });
        playbackObserver.observe(video);
      }
    });
  }

  /* ---------------------------------------------------------------
     Mobile sticky add-to-cart
     --------------------------------------------------------------- */
  function initStickyAtc(scope) {
    var root = scope || document;
    var sticky = root.querySelector('[data-estilo-sticky-atc]') || document.querySelector('[data-estilo-sticky-atc]');
    if (!sticky || sticky.dataset.estiloStickyInitialized === 'true') return;
    sticky.dataset.estiloStickyInitialized = 'true';

    var mediaQuery = window.matchMedia('(max-width: 749px)');
    var stickyButton = sticky.querySelector('[data-estilo-sticky-add]');
    var stickyPrice = sticky.querySelector('[data-estilo-sticky-price]');
    var variantChosen = new URLSearchParams(location.search).has('variant') || !document.querySelector('variant-selects');
    var visibilityObserver = null;
    var contentObserver = null;

    function getProductInfo() {
      return document.querySelector('product-info[id^="MainProduct-"]') || document.querySelector('product-info');
    }

    function getSubmitButton() {
      var productInfo = getProductInfo();
      var searchRoot = productInfo || document;
      return searchRoot.querySelector('[id^="ProductSubmitButton-"]:not([data-estilo-sticky-add]), .product-form__submit:not([data-estilo-sticky-add])');
    }

    function getPriceNode() {
      var productInfo = getProductInfo();
      var priceRoot = (productInfo || document).querySelector('[id^="price-"]');
      if (!priceRoot) return null;
      return priceRoot.querySelector('.price-item--sale, .price-item--regular') || priceRoot;
    }

    function hideSticky() {
      sticky.classList.remove('is-visible');
      sticky.setAttribute('hidden', '');
    }

    function showSticky() {
      if (!mediaQuery.matches || !sticky.hasAttribute('hidden')) return;
      sticky.removeAttribute('hidden');
      window.requestAnimationFrame(function () {
        sticky.classList.add('is-visible');
      });
    }

    function syncState() {
      var submit = getSubmitButton();
      var price = getPriceNode();

      if (stickyPrice && price) {
        var nextPrice = price.textContent.trim();
        if (stickyPrice.textContent.trim() !== nextPrice) {
          stickyPrice.textContent = nextPrice;
        }
      }

      if (!stickyButton || !submit) return;
      var disabled = submit.disabled || submit.getAttribute('aria-disabled') === 'true';
      if (stickyButton.disabled !== disabled) stickyButton.disabled = disabled;
      var ariaDisabled = disabled ? 'true' : 'false';
      if (stickyButton.getAttribute('aria-disabled') !== ariaDisabled) {
        stickyButton.setAttribute('aria-disabled', ariaDisabled);
      }

      if (!variantChosen && !disabled) {
        stickyButton.textContent = 'Choose options';
        stickyButton.setAttribute('aria-label', 'Choose product options');
        return;
      }
      stickyButton.removeAttribute('aria-label');
      var submitLabel = submit.querySelector('span');
      if (submitLabel && submitLabel.textContent.trim() && stickyButton.textContent.trim() !== submitLabel.textContent.trim()) {
        stickyButton.textContent = submitLabel.textContent.trim();
      }
    }

    function observePurchaseControl() {
      if (visibilityObserver) visibilityObserver.disconnect();
      var submit = getSubmitButton();
      if (!submit || !mediaQuery.matches || !('IntersectionObserver' in window)) {
        hideSticky();
        return;
      }

      visibilityObserver = new IntersectionObserver(function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting || entry.boundingClientRect.top > 0) {
            hideSticky();
          } else {
            showSticky();
          }
        });
      });
      visibilityObserver.observe(submit);
      syncState();
    }

    if (stickyButton) {
      stickyButton.addEventListener('click', function () {
        var submit = getSubmitButton();
        if (!submit || submit.disabled || submit.getAttribute('aria-disabled') === 'true') return;
        if (!variantChosen) {
          var choices = getProductInfo().querySelector('variant-selects');
          if (choices) { choices.scrollIntoView({ block: 'center', behavior: prefersReduced ? 'instant' : 'smooth' }); choices.querySelector('input,select,button')?.focus({ preventScroll: true }); }
          return;
        }
        submit.click();
      });
    }

    var productInfo = getProductInfo();
    if (productInfo) productInfo.addEventListener('change', function (event) {
      if (event.target.closest('variant-selects')) { variantChosen = true; syncState(); }
    });
    if (productInfo && 'MutationObserver' in window) {
      contentObserver = new MutationObserver(function () {
        syncState();
      });
      contentObserver.observe(productInfo, { childList: true, subtree: true, attributes: true });
    }

    if (typeof subscribe === 'function' && typeof PUB_SUB_EVENTS !== 'undefined') {
      subscribe(PUB_SUB_EVENTS.variantChange, function () {
        window.requestAnimationFrame(function () {
          syncState();
          observePurchaseControl();
        });
      });
    }

    if (typeof mediaQuery.addEventListener === 'function') {
      mediaQuery.addEventListener('change', observePurchaseControl);
    } else if (typeof mediaQuery.addListener === 'function') {
      mediaQuery.addListener(observePurchaseControl);
    }

    observePurchaseControl();
    // IntersectionObserver can miss a jump from fully below to fully above the viewport.
    var visibilityFrame = null;
    function checkScrollPosition() {
      if (!sticky.isConnected) { document.removeEventListener('scroll', checkScrollPosition); return; }
      if (visibilityFrame !== null) return;
      visibilityFrame = window.requestAnimationFrame(function () {
        visibilityFrame = null;
        var submit = getSubmitButton();
        if (mediaQuery.matches && submit && submit.getBoundingClientRect().bottom <= 0) showSticky();
        else hideSticky();
      });
    }
    document.addEventListener('scroll', checkScrollPosition, { passive: true });
    checkScrollPosition();
  }

  /* ---------------------------------------------------------------
     Reveal on scroll (IntersectionObserver) + staggered children
     --------------------------------------------------------------- */
  function initReveal(scope) {
    var root = scope || document;
    var reveals = root.querySelectorAll('.estilo-reveal');

    if (prefersReduced || !('IntersectionObserver' in window)) {
      reveals.forEach(function (el) {
        el.classList.add('is-visible');
      });
      return;
    }

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          if (entry.isIntersecting) {
            entry.target.classList.add('is-visible');
            observer.unobserve(entry.target);
          }
        });
      },
      { rootMargin: '0px 0px -8% 0px', threshold: 0.1 }
    );

    reveals.forEach(function (el) {
      if (el.dataset.estiloRevealInitialized === 'true') return;
      el.dataset.estiloRevealInitialized = 'true';
      observer.observe(el);
    });
  }

  /* ---------------------------------------------------------------
     Size guide toggle
     --------------------------------------------------------------- */
  function initSizeGuide(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-estilo-size-toggle]').forEach(function (btn) {
      if (btn.dataset.estiloSizeInitialized === 'true') return;
      btn.dataset.estiloSizeInitialized = 'true';
      btn.addEventListener('click', function () {
        var panel = document.getElementById(btn.getAttribute('aria-controls'));
        if (!panel) return;
        var open = panel.classList.toggle('is-open');
        btn.setAttribute('aria-expanded', open ? 'true' : 'false');
      });
    });
  }

  /* ---------------------------------------------------------------
     Hero subline rotation
     --------------------------------------------------------------- */
  function initHeroSubline(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-estilo-hero-sublines]').forEach(function (group) {
      if (group.dataset.estiloSublinesInitialized === 'true') return;
      group.dataset.estiloSublinesInitialized = 'true';

      var lines = Array.from(group.querySelectorAll('[data-estilo-hero-subline]'));
      if (!lines.length) return;

      var index = 0;
      var interval = null;
      var seconds = Number(group.dataset.rotationSeconds) || 4.5;

      function showLine(nextIndex) {
        index = nextIndex;
        lines.forEach(function (line, lineIndex) {
          var isActive = lineIndex === index;
          line.classList.toggle('is-active', isActive);
          line.setAttribute('aria-hidden', isActive ? 'false' : 'true');
        });
      }

      function stop() {
        if (!interval) return;
        window.clearInterval(interval);
        interval = null;
      }

      function start() {
        if (prefersReduced || lines.length < 2 || interval || document.visibilityState === 'hidden') return;
        interval = window.setInterval(function () {
          showLine((index + 1) % lines.length);
        }, Math.max(3, seconds) * 1000);
      }

      showLine(0);

      if (prefersReduced || lines.length < 2) return;

      if ('IntersectionObserver' in window) {
        var observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) start();
            else stop();
          });
        }, { threshold: 0.15 });
        observer.observe(group);
      } else {
        start();
      }

      document.addEventListener('visibilitychange', function () {
        if (document.visibilityState === 'hidden') stop();
        else start();
      });
    });
  }

  function initStagger(scope) {
    var root = scope || document;
    root.querySelectorAll('[data-stagger]').forEach(function (group) {
      Array.from(group.children).slice(0, 6).forEach(function (child, index) {
        child.style.setProperty('--reveal-index', String(index));
      });
    });
  }

  function initFooterMenus(scope) {
    var root = scope || document;
    root.querySelectorAll('.estilo-footer-menu').forEach(function (menu) {
      if (footerMediaQuery.matches) menu.removeAttribute('open');
      else menu.setAttribute('open', '');
    });
  }

  function initPreviewToolbarLabel() {
    var root = document.documentElement;
    if (root.dataset.estiloPreviewToolbarObserver === 'true') return;
    root.dataset.estiloPreviewToolbarObserver = 'true';

    function labelToolbar() {
      var frame = document.getElementById('PBarNextFrame');
      if (!frame) return false;
      if (!frame.title) frame.title = 'Shopify theme preview toolbar';
      return true;
    }

    if (labelToolbar() || !('MutationObserver' in window)) return;

    var observer = new MutationObserver(function () {
      if (!labelToolbar()) return;
      observer.disconnect();
    });
    observer.observe(document.body, { childList: true, subtree: true });
  }

  function init(scope) {
    var root = scope || document;
    root.querySelectorAll('.estilo-menu-kit').forEach(function (link) {
      if (link.dataset.kitMenuReady) return;
      link.dataset.kitMenuReady = 'true';
      link.addEventListener('click', function (event) {
        var target = document.getElementById('build-your-course-kit');
        var drawer = link.closest('header-drawer');
        if (target && drawer && typeof drawer.closeMenuDrawer === 'function') {
          target.tabIndex = -1;
          drawer.closeMenuDrawer(event, target);
          drawer.querySelector('summary').setAttribute('aria-expanded', 'false');
        }
      });
    });
    initHeroVideo(root);
    initStickyAtc(root);
    initStagger(root);
    initReveal(root);
    initSizeGuide(root);
    initHeroSubline(root);
    initFooterMenus(root);
    initPreviewToolbarLabel();
  }

  function handleFooterBreakpointChange() {
    initFooterMenus(document);
  }

  if (typeof footerMediaQuery.addEventListener === 'function') {
    footerMediaQuery.addEventListener('change', handleFooterBreakpointChange);
  } else if (typeof footerMediaQuery.addListener === 'function') {
    footerMediaQuery.addListener(handleFooterBreakpointChange);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', function (event) {
    init(event.target);
  });
})();
